import React, { FC } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { LoginSessionExpired } from "./LoginSessionExpired";
import { useTranslation } from "react-i18next";

export interface SessionExpiredAwareLoginComponentProps {
  children?: React.ReactNode;
}

export const LoginSessionExpiredAwareMessageNotifier: FC<
  SessionExpiredAwareLoginComponentProps
> = (props) => {
  const { t } = useTranslation("shared-ts-ui-identity");
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (LoginSessionExpired.isRaised()) {
      setOpen(true);
      LoginSessionExpired.lowerFlag();
    }
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t("Login Session Expired")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t(
              "Your login session has timed out. Please log in again to continue."
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            {t("OK")}
          </Button>
        </DialogActions>
      </Dialog>
      {props.children}
    </>
  );
};
